import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {
  Container,
  Typography,
  CircularProgress,
  Alert
} from '@mui/material';
import ProfileView from '../components/profile/ProfileView';
import socialService, { ProfileDto } from '../services/socialService';

const PublicProfile: React.FC = () => {
  const { aliasName } = useParams<{ aliasName: string }>();
  const [profile, setProfile] = useState<ProfileDto | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (aliasName) {
      loadProfile();
    }
  }, [aliasName]);

  const loadProfile = async () => {
    if (!aliasName) return;

    try {
      setLoading(true);
      setError(null);
      const data = await socialService.getProfile(aliasName);
      setProfile(data);
    } catch (error: any) {
      console.error('Failed to load profile:', error);
      setError('Profile not found or not accessible');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Container maxWidth="md" sx={{ py: 4, textAlign: 'center' }}>
        <CircularProgress />
        <Typography sx={{ mt: 2 }}>Loading profile...</Typography>
      </Container>
    );
  }

  if (error || !profile) {
    return (
      <Container maxWidth="md" sx={{ py: 4 }}>
        <Alert severity="error">
          {error || 'Profile not found'}
        </Alert>
      </Container>
    );
  }

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <ProfileView
        profile={profile}
        isOwner={false}
      />
    </Container>
  );
};

export default PublicProfile;

